import { useEffect, useState } from 'react';

export default function useStickToTopModal() {
    const modalClassName = "modal-stick-top";
    const [stickToTop, setStickToTop] = useState(false);

    useEffect(() => {

        const handleResize = () => {
            // اگر ارتفاع viewport تغییر کرد (نشانه باز یا بسته شدن کیبورد)
            const isKeyboardOpen = window.visualViewport?.height < window.innerHeight;
            setStickToTop(isKeyboardOpen);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        modalClassName,
        stickToTop,
    };
}
